export const launchUnsavedChangesAlert = () => {};
export const alertOrNavigate = () => {};
export const fixPhotoOrientation = file => file;
